import React from "react";

const SidebarLabel = ({labelName, labelDesc, children}) => {
    return (
        <React.Fragment>
            <div id={`pills-${labelName}`} className={`tab-pane fade`}>
                <ul className="nav" id={`menu-${labelName}`}>
                    <li className="nav-label">{labelDesc}</li>
                    {children}
                </ul>
            </div>
        </React.Fragment>
    )
}

export default SidebarLabel;
